import _ from 'lodash';

export default function selector(storeState, props) {
    const audiencesState = _.get(storeState, '...');
    return {};
}
